module.exports = __webpack_public_path__ + "static/media/stella.fe01d2f6.svg";